// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"3dff4676","164":"8ae8e22c","254":"d048017d","301":"eab229c6","444":"a3690434","453":"c78585d9"}[chunkId] + ".chunk.js";
};